import React, { useState } from 'react';

import { Flex } from '@chakra-ui/react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { ICellRendererParams } from 'ag-grid-community';
// import styled from '@emotion/styled';
import styled from 'styled-components';

import { Ellipsis } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledMenu = styled(Menu)`
  ul {
    padding: 8px;
  }
  & .MuiMenu-paper {
    box-shadow:
      2px 0px 4px 3px rgba(0, 0, 0, 0.12),
      0px 4px 4px 3px rgba(0, 0, 0, 0.08);
    margin-top: 48px;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  padding: 8px 16px 8px 6px;
  border-radius: 4px;
  font-family: inherit;
  &:hover {
    color: #104f95;
    background-color: #e6f1fd;
    svg {
      color: #104f95;
    }
  }
`;

interface Item {
  Component: (params: ICellRendererParams) => JSX.Element;
  action?: (params: ICellRendererParams) => void;
}

interface AgGridRowMenuCustomProps {
  menuItems: Item[];
  MenuIcon?: React.FC<{ boxSize?: string; color?: string }>;
}

export type AgGridRowMenuProps = AgGridRowMenuCustomProps & ICellRendererParams;

export const AgGridRowMenu = ({ menuItems, MenuIcon = Ellipsis, ...cellRendererParams }: AgGridRowMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<EventTarget>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Flex height="100%" alignItems="center" justifyContent="center">
      <Button
        aria-controls={open ? 'aggrid-menu' : undefined}
        aria-haspopup="true"
        disableRipple
        aria-expanded={open ? 'true' : undefined}
        style={{ backgroundColor: anchorEl ? '#e6f1fd' : null, minWidth: 'unset' }}
        onClick={handleClick}
      >
        <MenuIcon boxSize="24px" />
      </Button>
      <StyledMenu
        id="aggrid-menu"
        anchorEl={anchorEl}
        // keepMounted
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{
          zIndex: 1400,
        }}
        open={open}
        onClose={handleClose}
      >
        {menuItems.map((item) => {
          const { Component } = item;
          return (
            <StyledMenuItem
              onClick={() => {
                item.action(cellRendererParams);
                handleClose();
              }}
            >
              <Component {...cellRendererParams} />
            </StyledMenuItem>
          );
        })}
      </StyledMenu>
    </Flex>
  );
};

export const MenuItemComp = ({
  Icon,
  label,
}: {
  Icon: React.FC<{ boxSize?: string; color?: string }>;
  label: string;
}) => (
  <Flex>
    <Icon boxSize="20px" color="icon.g2" />
    <TextBodyMedium ml={2}>{label}</TextBodyMedium>
  </Flex>
);
